export const  convertArrayToSchema = (arr)  => {
  const result = {
      "type": "object",
      "properties": {},
      "options": {
        "layout": 'grid',
        "disable_properties": 'false',
    },
  };

  arr.forEach(item => {
      const properties = {};
      
      if (item.type === 'struct') {
          item.children.forEach(child => {
              properties[child.name] = {
                  "title": child.desc,
                  "type": child.type,
                  "format": "grid",
                  "options": {
                        "layout": 'grid',
                        "grid_columns": 6
                  },
                  "optional": child.optional
              };
          });
          result.properties[item.name] = {
              "title": item.desc,
              "type": "object",
              "properties": properties,
              "options": {
                "layout": 'grid',
              }
          };
      } else if (item.type === 'table') {
          result.properties[item.name] = {
              "title": item.desc.charAt(0).toUpperCase() + item.desc.slice(1),
              "type": "array",
              "items": {
                  "type": "object",
                  "title": "Table",
                  "properties": {},
                  "options": {
                    "layout": 'grid',
                },
                "required": item.children.filter(el => (String(el.optional) === "false" || el.optional === undefined) && el.type === "string").map(el => el.name),
              },
          };
          item.children.forEach(child => {
              if (child.type === 'table') {
                  result.properties[item.name].items.properties[child.name] = {
                      "title": child.desc.charAt(0).toUpperCase() + child.desc.slice(1),
                      "type": "array",
                      "format": "table",  // Add format key here
                      "items": {
                          "type": "object",
                          "title": child.desc,
                          "properties": {},
                          "required": child.children.filter(el => String(el.optional) === "false" || el.optional === undefined).map(el => el.name),
                      }
                  };
                  child.children.forEach(grandChild => {
                        if(grandChild.type === 'string' && grandChild.children) {
                            result.properties[item.name].items.properties[child.name].items.properties[grandChild.name] = {
                                "title": grandChild.desc,
                                "type": grandChild.type,
                                "enumSource": [{
                                    source: grandChild.children.map(option => ({title: option.desc, value: option.name})).sort((a, b) => a.title.localeCompare(b.title)),
                                    title: '{{item.title}}',
                                    value: '{{item.value}}'
                                }],
                                "options": {
                                    "input_width": "130px"
                                },
                                "optional": grandChild.optional 
                            };
                        } else if (grandChild.type === 'string' && grandChild.collection) {
                            result.properties[item.name].items.properties[child.name].items.properties[grandChild.name] = {
                                "title": grandChild.desc,
                                "type": "string",
                                "optional": grandChild.optional
                            };
                        } else if (["primary_key", "unique", "auto_increment", "not_null"].includes(grandChild.name)) {
                            result.properties[item.name].items.properties[child.name].items.properties[grandChild.name] = {
                                "title": grandChild.name === "primary_key" ? "PK" : grandChild.name === "unique" ? "UQ" : grandChild.name === "auto_increment" ? "AI" : grandChild.name === "not_null" ? "NN" : grandChild.desc,
                                "type": "boolean",
                                "format": "checkbox",
                                "optional": grandChild.optional 
                            };
                        } else if (["maxlen", "precision"].includes(grandChild.name)) {
                            result.properties[item.name].items.properties[child.name].items.properties[grandChild.name] = {
                                "title": grandChild.desc,
                                "type": grandChild.type,
                                "options": {
                                    "input_width": "80px"
                                },
                                "optional": grandChild.optional 
                            };
                        } else {
                            result.properties[item.name].items.properties[child.name].items.properties[grandChild.name] = {
                                "title": grandChild.desc,
                                "type": grandChild.type,
                                "optional": grandChild.optional 
                            };
                        }
                  });
              } else {
                  result.properties[item.name].items.properties[child.name] = {
                      "title": child.desc,
                      "type": child.type,
                      "options": {
                        "layout": 'grid',
                        "grid_columns": 6
                        },
                    "optional": child.optional 
                  };
              }
          });
      }
  });

  return result;
}
  

export function generateSchema(inputArray, actualData = {}) {
    function processNode(node, actual = {}) {
        // If the node is of type 'struct', process its children as an object
        if (node.type === 'struct') {
            const result = {};
            node.children.forEach(child => {
                if(child.type != undefined && child.type == "string"){
                    result[child.name] = processNode(child, actual[child.name] || "");
                }
                else{
                    result[child.name] = processNode(child, actual[child.name] || {});
                }
                
            });
            return result;
        }

        // If the node is a 'table' or 'collection', process it as an array of objects
        if (node.type === 'table' || (node.collection && node.type != 'string')) {
            const result = [];
            const actualArray = actual || [];
            const numEntries = actualArray.length > 0 ? actualArray.length : 1; // Ensure at least one object in array

            for (let i = 0; i < numEntries; i++) {
                const childResult = {};
                node.children.forEach(child => {
                    if(child.type && child.type == "string"){
                        childResult[child.name] = processNode(child, actualArray[i] ? actualArray[i][child.name] || "" : "");
                    }else{
                        childResult[child.name] = processNode(child, actualArray[i] ? actualArray[i][child.name] || {} : {});
                    }
                    
                });
                result.push(childResult);
            }

            return result;
        }

        // If it's a simple type (like 'string'), return the value or empty string
        return actual || "";
    }

    const schema = {};
    inputArray.forEach(item => {
        schema[item.name] = processNode(item, actualData[item.name] || {});
    });

    return schema;
}

export function removeRoutesFromArray(inputArray) {
    // Iterate over the array
    return inputArray.map((item) => {
      // Check if the current item has children and is an array
      if (Array.isArray(item.children)) {
        // Filter out the routes array from the children
        item.children = item.children.filter((child) => child.name !== 'routes');
        
        // Recursively apply the function to any children
        item.children = removeRoutesFromArray(item.children);
      }
      return item;
    });
  }

export  function cleanSchema(schema) {
    if(schema.tables){

        schema.tables = schema.tables.filter((table) => {
            // Check if the table name is empty
            if (!table.name) return false;
    
            // Check if the columns array is empty
            if (table.columns.length === 0) return false;
    
            // If after filtering, the columns array is empty, remove the table
            return table.columns.length > 0;
        });
        
    }
    

    return schema;
}
